import CarbonChartsVue from "@carbon/charts-vue";

const Plugin = {
  install(app) {
    app.use(CarbonChartsVue);
  },
};

export default Plugin;
